import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idContaReceber: number | null, openState: boolean) => void,
    onActionDelete: (idContaReceber: number | null, openState: boolean) => void,
    onActionCopy: (idContaReceber: number | null, openState: boolean) => void,
    onActionExportar: (idContaReceber: number) => void,
}

export const GenerateContasReceberListaColumns = ({
    onActionEdit,
    onActionDelete,
    onActionCopy,
    onActionExportar,

}: Props): GridColDef[] => {

    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "EA"; // EM ABERTO
            case 1: // RECEBIDA
                return "R";
            case 2: // OUTROS
                return "O";
            case 3: // ATRASADAS
                return "AT";
            case 4: // RECEBIMENTO PARCIAL
                return "PA";
            default:
                return "?";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "gray"; // em aberto
            case 1: // PAGO
                return "green";
            case 2: // OUTROS
                return "yellow";
            case 3: // ATRASADA
                return "red";
            case 4: // RECEBIMENTO PARCIAL
                return "blue";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "Conta em aberto";
            case 1: // PAGO
                return "Conta recebida";
            case 2: // OUTROS
                return "Outros";
            case 3: // EM ABERTO
                return "Conta atrasada";
            case 4: // RECEBIMENTO PARCIAL
                return "Recebimento Parcial";
            default:
                return "?";
        }
    };


    return [
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 65,
            width: 65,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },
        {
            field: "nrContasReceber",
            filterable: false,
            headerName: "N°",
            minWidth: 70,
            width: 70,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        },
        {
            field: "nrParcela",
            filterable: false,
            headerName: "N° Parcela",
            minWidth: 90,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        }, {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro Custo",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        }, {
            field: "nroOrdemCompra",
            filterable: false,
            headerName: "OC",
            headerAlign: "center",
            minWidth: 70,
            width: 70,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        },
        {
            field: "nomeCliente",
            filterable: false,
            headerName: "Cliente",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        },
        {
            field: "nrContrato",
            filterable: false,
            headerName: "N° Contrato",
            minWidth: 90,
            width: 90,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        },
        {
            field: "nomeSubConta",
            filterable: false,
            headerName: "Subconta",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "nome",
            filterable: false,
            headerName: "Titulo",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "valorReceber",
            filterable: false,
            headerName: "Valor Receber",
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataReceber",
            filterable: false,
            headerName: "Data Receber",
            minWidth: 90,
            width: 90,
            sortable: false,
            align: "center",
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "valorBaixa",
            filterable: false,
            headerName: "Valor Recebido",
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataBaixa",
            filterable: false,
            headerName: "Data Recebido",
            minWidth: 90,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "exportar",
            filterable: false,
            headerName: "Exportar",
            sortable: false,
            valueGetter: (_, row) => row['idContasReceber'] as number,
            renderCell: ({ value }) => {
                return (
                    <Button
                        onMouseDown={() => onActionExportar(value)}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.2rem solid #45b6af',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        Exportar
                    </Button>
                );
            },
        },
        {
            field: 'idContasReceber',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionCopy(params.value, true)}>
                            <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }

    ];

}